import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f50e7b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3f50e7b6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50e7b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f50e7b6')) {
      api.createRecord('3f50e7b6', component.options)
    } else {
      api.reload('3f50e7b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f50e7b6&scoped=true", function () {
      api.rerender('3f50e7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settlement/apply/index.vue"
export default component.exports